import React, {
    Component,
    PropTypes
} from 'react';
var ReactBsTable = require('react-bootstrap-table');
var BootstrapTable = ReactBsTable.BootstrapTable;
var TableHeaderColumn = ReactBsTable.TableHeaderColumn;
import SearchDate from 'CONFIG/component/search/searchDate'
import Tip from 'CONFIG/component/tip'
import ellaService from 'SERVICES/purifier/ella/ellaService'
import {language, pageOption} from 'UTIL/common'
import {timesTampsToData} from '../../../function'
import LongSearchInput from 'CONFIG/component/search/longSearchInput'
export default class MsgIndex extends Component {
    constructor(props) {
        super(props);
        this.search = this.search.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.state = {
            list: [],
            size: 10,
            current: 1,
            total: 0,
            delRow: {id: "", name: ""},
        };
    }

    componentDidMount() {
        $("#time").val('');
        this.onPageChange(this.state.current, this.state.size);
    }

    onPageChange(page, sizePerPage, e) {
        const search = $.trim($("#search").val());
        var gmtCreateBgn = $("#time").val()==""?"":$("#time").val().split("至")[0];
        var gmtCreateEnd = $("#time").val()==""?"":$("#time").val().split("至")[1];
        const json = {
            current: page,
            size: sizePerPage,
            search: search,
            searchBgnTime: gmtCreateBgn == '' ? "" : gmtCreateBgn + " 00:00:00",
            searchEndTime: gmtCreateEnd == '' ? '' : gmtCreateEnd + " 23:59:59",
        };
        const data = JSON.stringify(json);
        ellaService.messageLog({data}).then(body => {
            console.log(body)
            if (body.code == 8001) {
                this.setState({
                    current: body.data.current,
                    size: body.data.size,
                    list: body.data.records,
                    total: body.data.total
                })
            }
        })

    }

    search() {
        this.onPageChange(1, this.state.size);
    }

    dateHanle(cell, row) {
        return timesTampsToData(row.gmtSend).split(" ")[0];
    }

    reset() {
        $("#search").val('');
        $("#time").val('');
        this.onPageChange(1, 10)
    }
    render() {
        let options = pageOption(this.state.current, this.state.size);
        options['onPageChange'] = this.onPageChange.bind(this);
        return (
            <div>
                <section className="content-header ">
                    <h1>{language()['userManage']}
                        <small>{language()['TextQuery']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-list"></i>
                            <h3 className="box-title">{language()['TextQueryList']}</h3>
                        </div>
                        <div className="box-body">
                            <Tip ids=""/>
                            <div className="title-box">
                                <div className="clearfix">
                                    <LongSearchInput id="search" name={language()['telephone']+"/"+language()['MessageContent']}/>
                                    <SearchDate name="sendTime" id="time"/>
                                    <button type="button" className="btn btn-info" id="search"
                                            onClick={this.search.bind(this)}>{language()['query']}</button>
                                    &nbsp;&nbsp;
                                    <button type="button" className="btn btn-warning" id="reset"
                                            onClick={this.reset.bind(this)}>{language()['resetting']}</button>
                                </div>
                            </div>

                            <div >
                                <BootstrapTable data={this.state.list} remote={true}
                                                fetchInfo={{dataTotalSize: this.state.total}} striped hover
                                                pagination={true} options={options} ref='table'>
                                    <TableHeaderColumn isKey dataField='id' hidden={true}> id</TableHeaderColumn>
                                    <TableHeaderColumn dataField='telNo' width="150"> {language()['telephone']} </TableHeaderColumn>
                                    <TableHeaderColumn dataField='content'width="500">{language()['MessageContent']}</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={this.dateHanle.bind(this)}
                                                       width="150">{language()['sendTime']}</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./modules/ella/user/msg/msgIndex.js